import { Injectable } from '@angular/core';

export interface CountryDDI {
  name: string;
  code: string;
  ddi: string;
}

@Injectable({
  providedIn: 'root'
})
export class DdiCountries {
  countriesDDI: CountryDDI[] = [
    { name: 'Afghanistan', code: 'AF', ddi: '+93' },
    { name: 'Åland Islands', code: 'AX', ddi: '+358' },
    { name: 'Albania', code: 'AL', ddi: '+355' },
    { name: 'Algeria', code: 'DZ', ddi: '+213' },
    { name: 'American Samoa', code: 'AS', ddi: '+1-684' },
    { name: 'Andorra', code: 'AD', ddi: '+376' },
    { name: 'Angola', code: 'AO', ddi: '+244' },
    { name: 'Anguilla', code: 'AI', ddi: '+1-264' },
    { name: 'Antarctica', code: 'AQ', ddi: '+672' },
    { name: 'Antigua and Barbuda', code: 'AG', ddi: '+1-268' },
    { name: 'Argentina', code: 'AR', ddi: '+54' },
    { name: 'Armenia', code: 'AM', ddi: '+374' },
    { name: 'Aruba', code: 'AW', ddi: '+297' },
    { name: 'Australia', code: 'AU', ddi: '+61' },
    { name: 'Austria', code: 'AT', ddi: '+43' },
    { name: 'Azerbaijan', code: 'AZ', ddi: '+994' },
    { name: 'Bahamas', code: 'BS', ddi: '+1-242' },
    { name: 'Bahrain', code: 'BH', ddi: '+973' },
    { name: 'Bangladesh', code: 'BD', ddi: '+880' },
    { name: 'Barbados', code: 'BB', ddi: '+1-246' },
    { name: 'Belarus', code: 'BY', ddi: '+375' },
    { name: 'Belgium', code: 'BE', ddi: '+32' },
    { name: 'Belize', code: 'BZ', ddi: '+501' },
    { name: 'Benin', code: 'BJ', ddi: '+229' },
    { name: 'Bermuda', code: 'BM', ddi: '+1-441' },
    { name: 'Bhutan', code: 'BT', ddi: '+975' },
    { name: 'Bolivia', code: 'BO', ddi: '+591' },
    { name: 'Bosnia and Herzegovina', code: 'BA', ddi: '+387' },
    { name: 'Botswana', code: 'BW', ddi: '+267' },
    { name: 'Bouvet Island', code: 'BV', ddi: '+47' },
    { name: 'Brazil', code: 'BR', ddi: '+55' },
    { name: 'British Indian Ocean Territory', code: 'IO', ddi: '+246' },
    { name: 'Brunei Darussalam', code: 'BN', ddi: '+673' },
    { name: 'Bulgaria', code: 'BG', ddi: '+359' },
    { name: 'Burkina Faso', code: 'BF', ddi: '+226' },
    { name: 'Burundi', code: 'BI', ddi: '+257' },
    { name: 'Cambodia', code: 'KH', ddi: '+855' },
    { name: 'Cameroon', code: 'CM', ddi: '+237' },
    { name: 'Canada', code: 'CA', ddi: '+1' },
    { name: 'Cape Verde', code: 'CV', ddi: '+238' },
    { name: 'Cayman Islands', code: 'KY', ddi: '+1-345' },
    { name: 'Central African Republic', code: 'CF', ddi: '+236' },
    { name: 'Chad', code: 'TD', ddi: '+235' },
    { name: 'Chile', code: 'CL', ddi: '+56' },
    { name: 'China', code: 'CN', ddi: '+86' },
    { name: 'Christmas Island', code: 'CX', ddi: '+61' },
    { name: 'Cocos (Keeling) Islands', code: 'CC', ddi: '+61' },
    { name: 'Colombia', code: 'CO', ddi: '+57' },
    { name: 'Comoros', code: 'KM', ddi: '+269' },
    { name: 'Congo', code: 'CG', ddi: '+242' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD', ddi: '+243' },
    { name: 'Cook Islands', code: 'CK', ddi: '+682' },
    { name: 'Costa Rica', code: 'CR', ddi: '+506' },
    { name: "Cote D'Ivoire", code: 'CI', ddi: '+225' },
    { name: 'Croatia', code: 'HR', ddi: '+385' },
    { name: 'Cuba', code: 'CU', ddi: '+53' },
    { name: 'Cyprus', code: 'CY', ddi: '+357' },
    { name: 'Czech Republic', code: 'CZ', ddi: '+420' },
    { name: 'Denmark', code: 'DK', ddi: '+45' },
    { name: 'Djibouti', code: 'DJ', ddi: '+253' },
    { name: 'Dominica', code: 'DM', ddi: '+1-767' },
    { name: 'Dominican Republic', code: 'DO', ddi: '+1-809' },
    { name: 'Ecuador', code: 'EC', ddi: '+593' },
    { name: 'Egypt', code: 'EG', ddi: '+20' },
    { name: 'El Salvador', code: 'SV', ddi: '+503' },
    { name: 'Equatorial Guinea', code: 'GQ', ddi: '+240' },
    { name: 'Eritrea', code: 'ER', ddi: '+291' },
    { name: 'Estonia', code: 'EE', ddi: '+372' },
    { name: 'Ethiopia', code: 'ET', ddi: '+251' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK', ddi: '+500' },
    { name: 'Faroe Islands', code: 'FO', ddi: '+298' },
    { name: 'Fiji', code: 'FJ', ddi: '+679' },
    { name: 'Finland', code: 'FI', ddi: '+358' },
    { name: 'France', code: 'FR', ddi: '+33' },
    { name: 'French Guiana', code: 'GF', ddi: '+594' },
    { name: 'French Polynesia', code: 'PF', ddi: '+689' },
    { name: 'French Southern Territories', code: 'TF', ddi: '+262' },
    { name: 'Gabon', code: 'GA', ddi: '+241' },
    { name: 'Gambia', code: 'GM', ddi: '+220' },
    { name: 'Georgia', code: 'GE', ddi: '+995' },
    { name: 'Germany', code: 'DE', ddi: '+49' },
    { name: 'Ghana', code: 'GH', ddi: '+233' },
    { name: 'Gibraltar', code: 'GI', ddi: '+350' },
    { name: 'Greece', code: 'GR', ddi: '+30' },
    { name: 'Greenland', code: 'GL', ddi: '+299' },
    { name: 'Grenada', code: 'GD', ddi: '+1-473' },
    { name: 'Guadeloupe', code: 'GP', ddi: '+590' },
    { name: 'Guam', code: 'GU', ddi: '+1-671' },
    { name: 'Guatemala', code: 'GT', ddi: '+502' },
    { name: 'Guernsey', code: 'GG', ddi: '+44' },
    { name: 'Guinea', code: 'GN', ddi: '+224' },
    { name: 'Guinea-Bissau', code: 'GW', ddi: '+245' },
    { name: 'Guyana', code: 'GY', ddi: '+592' },
    { name: 'Haiti', code: 'HT', ddi: '+509' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM', ddi: '+672' },
    { name: 'Holy See (Vatican City State)', code: 'VA', ddi: '+379' },
    { name: 'Honduras', code: 'HN', ddi: '+504' },
    { name: 'Hong Kong', code: 'HK', ddi: '+852' },
    { name: 'Hungary', code: 'HU', ddi: '+36' },
    { name: 'Iceland', code: 'IS', ddi: '+354' },
    { name: 'India', code: 'IN', ddi: '+91' },
    { name: 'Indonesia', code: 'ID', ddi: '+62' },
    { name: 'Iran, Islamic Republic Of', code: 'IR', ddi: '+98' },
    { name: 'Iraq', code: 'IQ', ddi: '+964' },
    { name: 'Ireland', code: 'IE', ddi: '+353' },
    { name: 'Isle of Man', code: 'IM', ddi: '+44' },
    { name: 'Israel', code: 'IL', ddi: '+972' },
    { name: 'Italy', code: 'IT', ddi: '+39' },
    { name: 'Jamaica', code: 'JM', ddi: '+1-876' },
    { name: 'Japan', code: 'JP', ddi: '+81' },
    { name: 'Jersey', code: 'JE', ddi: '+44' },
    { name: 'Jordan', code: 'JO', ddi: '+962' },
    { name: 'Kazakhstan', code: 'KZ', ddi: '+7' },
    { name: 'Kenya', code: 'KE', ddi: '+254' },
    { name: 'Kiribati', code: 'KI', ddi: '+686' },
    { name: "Korea, Democratic People'S Republic of", code: 'KP', ddi: '+850' },
    { name: 'Korea, Republic of', code: 'KR', ddi: '+82' },
    { name: 'Kuwait', code: 'KW', ddi: '+965' },
    { name: 'Kyrgyzstan', code: 'KG', ddi: '+996' },
    { name: "Lao People'S Democratic Republic", code: 'LA', ddi: '+856' },
    { name: 'Latvia', code: 'LV', ddi: '+371' },
    { name: 'Lebanon', code: 'LB', ddi: '+961' },
    { name: 'Lesotho', code: 'LS', ddi: '+266' },
    { name: 'Liberia', code: 'LR', ddi: '+231' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY', ddi: '+218' },
    { name: 'Liechtenstein', code: 'LI', ddi: '+423' },
    { name: 'Lithuania', code: 'LT', ddi: '+370' },
    { name: 'Luxembourg', code: 'LU', ddi: '+352' },
    { name: 'Macao', code: 'MO', ddi: '+853' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK', ddi: '+389' },
    { name: 'Madagascar', code: 'MG', ddi: '+261' },
    { name: 'Malawi', code: 'MW', ddi: '+265' },
    { name: 'Malaysia', code: 'MY', ddi: '+60' },
    { name: 'Maldives', code: 'MV', ddi: '+960' },
    { name: 'Mali', code: 'ML', ddi: '+223' },
    { name: 'Malta', code: 'MT', ddi: '+356' },
    { name: 'Marshall Islands', code: 'MH', ddi: '+692' },
    { name: 'Martinique', code: 'MQ', ddi: '+596' },
    { name: 'Mauritania', code: 'MR', ddi: '+222' },
    { name: 'Mauritius', code: 'MU', ddi: '+230' },
    { name: 'Mayotte', code: 'YT', ddi: '+262' },
    { name: 'Mexico', code: 'MX', ddi: '+52' },
    { name: 'Micronesia, Federated States of', code: 'FM', ddi: '+691' },
    { name: 'Moldova, Republic of', code: 'MD', ddi: '+373' },
    { name: 'Monaco', code: 'MC', ddi: '+377' },
    { name: 'Mongolia', code: 'MN', ddi: '+976' },
    { name: 'Montserrat', code: 'MS', ddi: '+1-664' },
    { name: 'Morocco', code: 'MA', ddi: '+212' },
    { name: 'Mozambique', code: 'MZ', ddi: '+258' },
    { name: 'Myanmar', code: 'MM', ddi: '+95' },
    { name: 'Namibia', code: 'NA', ddi: '+264' },
    { name: 'Nauru', code: 'NR', ddi: '+674' },
    { name: 'Nepal', code: 'NP', ddi: '+977' },
    { name: 'Netherlands', code: 'NL', ddi: '+31' },
    { name: 'Netherlands Antilles', code: 'AN', ddi: '+599' },
    { name: 'New Caledonia', code: 'NC', ddi: '+687' },
    { name: 'New Zealand', code: 'NZ', ddi: '+64' },
    { name: 'Nicaragua', code: 'NI', ddi: '+505' },
    { name: 'Niger', code: 'NE', ddi: '+227' },
    { name: 'Nigeria', code: 'NG', ddi: '+234' },
    { name: 'Niue', code: 'NU', ddi: '+683' },
    { name: 'Norfolk Island', code: 'NF', ddi: '+672' },
    { name: 'Northern Mariana Islands', code: 'MP', ddi: '+1-670' },
    { name: 'Norway', code: 'NO', ddi: '+47' },
    { name: 'Oman', code: 'OM', ddi: '+968' },
    { name: 'Pakistan', code: 'PK', ddi: '+92' },
    { name: 'Palau', code: 'PW', ddi: '+680' },
    { name: 'Palestinian Territory, Occupied', code: 'PS', ddi: '+970' },
    { name: 'Panama', code: 'PA', ddi: '+507' },
    { name: 'Papua New Guinea', code: 'PG', ddi: '+675' },
    { name: 'Paraguay', code: 'PY', ddi: '+595' },
    { name: 'Peru', code: 'PE', ddi: '+51' },
    { name: 'Philippines', code: 'PH', ddi: '+63' },
    { name: 'Pitcairn', code: 'PN', ddi: '+64' },
    { name: 'Poland', code: 'PL', ddi: '+48' },
    { name: 'Portugal', code: 'PT', ddi: '+351' },
    { name: 'Puerto Rico', code: 'PR', ddi: '+1-787' },
    { name: 'Qatar', code: 'QA', ddi: '+974' },
    { name: 'Reunion', code: 'RE', ddi: '+262' },
    { name: 'Romania', code: 'RO', ddi: '+40' },
    { name: 'Russian Federation', code: 'RU', ddi: '+7' },
    { name: 'RWANDA', code: 'RW', ddi: '+250' },
    { name: 'Saint Helena', code: 'SH', ddi: '+290' },
    { name: 'Saint Kitts and Nevis', code: 'KN', ddi: '+1-869' },
    { name: 'Saint Lucia', code: 'LC', ddi: '+1-758' },
    { name: 'Saint Pierre and Miquelon', code: 'PM', ddi: '+508' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC', ddi: '+1-784' },
    { name: 'Samoa', code: 'WS', ddi: '+685' },
    { name: 'San Marino', code: 'SM', ddi: '+378' },
    { name: 'Sao Tome and Principe', code: 'ST', ddi: '+239' },
    { name: 'Saudi Arabia', code: 'SA', ddi: '+966' },
    { name: 'Senegal', code: 'SN', ddi: '+221' },
    { name: 'Serbia and Montenegro', code: 'CS', ddi: '+381' },
    { name: 'Seychelles', code: 'SC', ddi: '+248' },
    { name: 'Sierra Leone', code: 'SL', ddi: '+232' },
    { name: 'Singapore', code: 'SG', ddi: '+65' },
    { name: 'Slovakia', code: 'SK', ddi: '+421' },
    { name: 'Slovenia', code: 'SI', ddi: '+386' },
    { name: 'Solomon Islands', code: 'SB', ddi: '+677' },
    { name: 'Somalia', code: 'SO', ddi: '+252' },
    { name: 'South Africa', code: 'ZA', ddi: '+27' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS', ddi: '+500' },
    { name: 'Spain', code: 'ES', ddi: '+34' },
    { name: 'Sri Lanka', code: 'LK', ddi: '+94' },
    { name: 'Sudan', code: 'SD', ddi: '+249' },
    { name: 'Suriname', code: 'SR', ddi: '+597' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ', ddi: '+47' },
    { name: 'Swaziland', code: 'SZ', ddi: '+268' },
    { name: 'Sweden', code: 'SE', ddi: '+46' },
    { name: 'Switzerland', code: 'CH', ddi: '+41' },
    { name: 'Syrian Arab Republic', code: 'SY', ddi: '+963' },
    { name: 'Taiwan, Province of China', code: 'TW', ddi: '+886' },
    { name: 'Tajikistan', code: 'TJ', ddi: '+992' },
    { name: 'Tanzania, United Republic of', code: 'TZ', ddi: '+255' },
    { name: 'Thailand', code: 'TH', ddi: '+66' },
    { name: 'Timor-Leste', code: 'TL', ddi: '+670' },
    { name: 'Togo', code: 'TG', ddi: '+228' },
    { name: 'Tokelau', code: 'TK', ddi: '+690' },
    { name: 'Tonga', code: 'TO', ddi: '+676' },
    { name: 'Trinidad and Tobago', code: 'TT', ddi: '+1-868' },
    { name: 'Tunisia', code: 'TN', ddi: '+216' },
    { name: 'Turkey', code: 'TR', ddi: '+90' },
    { name: 'Turkmenistan', code: 'TM', ddi: '+993' },
    { name: 'Turks and Caicos Islands', code: 'TC', ddi: '+1-649' },
    { name: 'Tuvalu', code: 'TV', ddi: '+688' },
    { name: 'Uganda', code: 'UG', ddi: '+256' },
    { name: 'Ukraine', code: 'UA', ddi: '+380' },
    { name: 'United Arab Emirates', code: 'AE', ddi: '+971' },
    { name: 'United Kingdom', code: 'GB', ddi: '+44' },
    { name: 'United States', code: 'US', ddi: '+1' },
    { name: 'United States Minor Outlying Islands', code: 'UM', ddi: '+1' },
    { name: 'Uruguay', code: 'UY', ddi: '+598' },
    { name: 'Uzbekistan', code: 'UZ', ddi: '+998' },
    { name: 'Vanuatu', code: 'VU', ddi: '+678' },
    { name: 'Venezuela', code: 'VE', ddi: '+58' },
    { name: 'Viet Nam', code: 'VN', ddi: '+84' },
    { name: 'Virgin Islands, British', code: 'VG', ddi: '+1-284' },
    { name: 'Virgin Islands, U.S.', code: 'VI', ddi: '+1-340' },
    { name: 'Wallis and Futuna', code: 'WF', ddi: '+681' },
    { name: 'Western Sahara', code: 'EH', ddi: '+212' },
    { name: 'Yemen', code: 'YE', ddi: '+967' },
    { name: 'Zambia', code: 'ZM', ddi: '+260' },
    { name: 'Zimbabwe', code: 'ZW', ddi: '+263' }
  ];

  constructor() { }
}
